/* generato da strumenti/tema-shopify.py da sito/assets/js/main.js — non modificare qui */
/* SHUNGITE M.A.Y.A. — landing (step 5 e 5-bis) */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('js');

  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');
  var testata = document.getElementById('testata');
  var menu = document.getElementById('menu');
  var menuBtn = document.querySelector('.menu-btn');

  /* ── profondità leggera: la foto dell'apertura e quelle dei racconti (solo col mouse) ── */
  var aperturaFoto = document.querySelector('.apertura__foto, .intestazione__foto');
  var racconti = Array.prototype.slice.call(document.querySelectorAll('.racconto__foto'));
  var visibili = new Set();
  if ('IntersectionObserver' in window) {
    var ossFoto = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) visibili.add(v.target); else visibili.delete(v.target); });
      richiedi();
    });
    racconti.forEach(function (el) { ossFoto.observe(el); });
  }
  function profondita() {
    var attiva = mouse.matches && !calmo;
    if (aperturaFoto) {
      var y = window.scrollY;
      aperturaFoto.style.transform = attiva && y < window.innerHeight * 1.2 ? 'translate3d(0,' + (y * 0.22).toFixed(1) + 'px,0)' : '';
    }
    racconti.forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) return;
      if (!attiva) { img.style.removeProperty('--sposta'); img.style.removeProperty('--zoom'); return; }
      if (!visibili.has(box)) return;
      var r = box.getBoundingClientRect();
      var centro = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; /* da -1 a 1 circa */
      img.style.setProperty('--zoom', '1.12');
      img.style.setProperty('--sposta', (centro * -36).toFixed(1) + 'px');
    });
  }

  /* ── un solo gestore di scroll, con requestAnimationFrame ── */
  var inAttesa = false;
  var ultimoY = window.scrollY;
  function aggiorna() {
    inAttesa = false;
    var y = window.scrollY;
    if (testata) {
      testata.classList.toggle('scorsa', y > 24);
      var menuAperto = menuBtn && menuBtn.getAttribute('aria-expanded') === 'true';
      var dentro = testata.contains(document.activeElement);
      if (menuAperto || dentro || y < 480 || y < ultimoY - 4) testata.classList.remove('nascosta');
      else if (y > ultimoY + 6) testata.classList.add('nascosta');
    }
    ultimoY = y;
    profondita();
  }
  function richiedi() {
    if (!inAttesa) { inAttesa = true; window.requestAnimationFrame(aggiorna); }
  }
  window.addEventListener('scroll', richiedi, { passive: true });
  window.addEventListener('resize', richiedi, { passive: true });
  if (testata) testata.addEventListener('focusin', function () { testata.classList.remove('nascosta'); });
  aggiorna();

  /* ── menu da telefono ── */
  function chiudiMenu(rimettiFuoco) {
    if (!menu || !menuBtn) return;
    menu.classList.remove('aperto');
    testata.classList.remove('menu-aperto');
    menuBtn.setAttribute('aria-expanded', 'false');
    if (!menuBtn.querySelector('.vh')) menuBtn.setAttribute('aria-label', (window.mayaT && window.mayaT.apriMenu) || 'Apri il menu');
    if (rimettiFuoco) menuBtn.focus();
  }
  if (menu && menuBtn) {
    menuBtn.addEventListener('click', function () {
      var aperto = menuBtn.getAttribute('aria-expanded') === 'true';
      if (aperto) { chiudiMenu(false); return; }
      menu.classList.add('aperto');
      testata.classList.add('menu-aperto');
      testata.classList.remove('nascosta');
      menuBtn.setAttribute('aria-expanded', 'true');
    if (!menuBtn.querySelector('.vh')) menuBtn.setAttribute('aria-label', menuBtn.getAttribute('aria-expanded') === 'true' ? ((window.mayaT && window.mayaT.chiudiMenu) || 'Chiudi il menu') : ((window.mayaT && window.mayaT.apriMenu) || 'Apri il menu'));
    });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) chiudiMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuBtn.getAttribute('aria-expanded') === 'true') chiudiMenu(true);
    });
    document.addEventListener('click', function (e) {
      if (menuBtn.getAttribute('aria-expanded') === 'true' && !testata.contains(e.target)) chiudiMenu(false);
    });
  }

  /* ── la voce del menu segue la sezione che si sta leggendo ── */
  var vociMenu = menu ? Array.prototype.slice.call(menu.querySelectorAll('a[href^="#"]')) : [];
  if ('IntersectionObserver' in window && vociMenu.length) {
    var perId = {};
    vociMenu.forEach(function (a) { perId[a.getAttribute('href').slice(1)] = a; });
    var ossMenu = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (!v.isIntersecting) return;
        var a = perId[v.target.id];
        if (!a) return;
        vociMenu.forEach(function (x) { x.classList.toggle('attivo', x === a); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(perId).forEach(function (id) { var s = document.getElementById(id); if (s) ossMenu.observe(s); });
  }

  /* ── entrate allo scroll: nelle griglie uno dopo l'altro ── */
  var daMostrare = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  daMostrare.forEach(function (el) {
    var fratelli = Array.prototype.filter.call(el.parentElement.children, function (x) { return x.classList.contains('reveal'); });
    var i = fratelli.indexOf(el);
    if (fratelli.length > 1 && i % 4 > 0) el.style.setProperty('--i', i % 4);   /* il ritmo va per riga, non per pagina */
  });
  function mostra(el) {
    el.classList.add('in');
    var i = parseFloat(el.style.getPropertyValue('--i')) || 0;
    window.setTimeout(function () { el.classList.add('fatto'); }, 1400 + i * 180);
  }
  if ('IntersectionObserver' in window && !calmo) {
    var oss = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) { mostra(v.target); oss.unobserve(v.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    daMostrare.forEach(function (el) { oss.observe(el); });
  } else {
    daMostrare.forEach(function (el) { el.classList.add('in', 'fatto'); });
  }

  /* ── domande frequenti: una aperta alla volta, si apre morbida ── */
  var bottoni = Array.prototype.slice.call(document.querySelectorAll('.voce__btn'));
  bottoni.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var aperto = btn.getAttribute('aria-expanded') === 'true';
      bottoni.forEach(function (altro) {
        altro.setAttribute('aria-expanded', 'false');
        altro.closest('.voce').classList.remove('aperta');
      });
      if (!aperto) {
        btn.setAttribute('aria-expanded', 'true');
        btn.closest('.voce').classList.add('aperta');
      }
    });
  });

  /* ── modulo contatti: all'invio valido prepara l'email (mailto), come l'ordine ── */
  var modulo = document.getElementById('modulo') || document.getElementById('modulo-contatti');
  var messaggio = document.getElementById('messaggio');
  try {   /* «Chiedi il prezzo» arriva col messaggio già scritto */
    var daUrl = new URLSearchParams(window.location.search).get('messaggio');
    if (messaggio && daUrl && !messaggio.value.trim()) messaggio.value = daUrl.slice(0, 600) + ' ';
  } catch (e) {}
  document.querySelectorAll('[data-richiesta]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (messaggio && !messaggio.value.trim()) messaggio.value = link.getAttribute('data-richiesta') + ' ';
    });
  });
  if (modulo) {
    var esito = modulo.querySelector('[data-esito]');
    var regole = [
      { id: 'nome', ok: function (el) { return el.value.trim().length > 1; } },
      { id: 'email', ok: function (el) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim()); } },
      { id: 'messaggio', ok: function (el) { return el.value.trim().length > 2; } }
    ].filter(function (r) { return document.getElementById(r.id); });
    function segna(regola) {
      var el = document.getElementById(regola.id);
      var err = document.getElementById('errore-' + regola.id);
      var valido = regola.ok(el);
      el.setAttribute('aria-invalid', valido ? 'false' : 'true');
      if (err) err.hidden = valido;
      return valido;
    }
    /* l'errore sparisce mentre si corregge, mai al blur: un messaggio che si chiude al blur
       sposta la pagina fra il mousedown e il mouseup e il clic successivo va a vuoto */
    regole.forEach(function (r) {
      var el = document.getElementById(r.id);
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') segna(r); });
    });
    function val(id) { return document.getElementById(id).value.trim(); }
    function oggetto() { return (modulo.getAttribute('data-oggetto') || '') + ' – ' + val('nome'); }
    function corpo() { return val('messaggio') + '\n\n' + val('nome') + '\n' + val('email'); }
    modulo.addEventListener('submit', function (e) {
      var vero = !modulo.getAttribute('data-email');   /* Shopify: il modulo invia davvero */
      if (!vero) e.preventDefault();
      var primoErrore = null;
      regole.forEach(function (r) {
        if (!segna(r) && !primoErrore) primoErrore = document.getElementById(r.id);
      });
      if (primoErrore) { e.preventDefault(); if (esito) esito.hidden = true; primoErrore.focus(); return; }
      if (vero) return;
      window.location.href = 'mailto:' + modulo.getAttribute('data-email') + '?subject=' + encodeURIComponent(oggetto()) +
        '&body=' + encodeURIComponent(corpo());
      if (esito) {
        var c = esito.querySelector('[data-copiato]'); if (c) c.hidden = true;
        esito.hidden = false;
        esito.focus({ preventScroll: true });
        esito.scrollIntoView({ block: 'nearest' });
      }
    });
    var copia = modulo.querySelector('[data-copia-messaggio]');
    if (copia) copia.addEventListener('click', function () {   /* lo stesso testo dell'email, oggetto escluso */
      copiaTesto(corpo(), function () { var c = esito.querySelector('[data-copiato]'); if (c) c.hidden = false; });
    });
  }

  /* ── copiare negli appunti (con la via vecchia se il browser non lo permette) ── */
  function copiaTesto(t, fatto) {
    function vecchio() {
      var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', '');
      a.style.position = 'fixed'; a.style.opacity = '0';
      document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (er) {}
      document.body.removeChild(a); fatto();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(fatto, vecchio);
    else vecchio();
  }

  /* ── Spedizioni e resi: «Copia il modulo» copia il modulo tipo così com'è ── */
  document.querySelectorAll('[data-copia-modulo]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sez = b.closest('section'), m = sez && sez.querySelector('[data-modulo-testo]');
      if (!m) return;
      var t = Array.prototype.map.call(m.querySelectorAll('h2, p, li'), function (x) { return x.textContent.replace(/\s+/g, ' ').trim(); }).join('\n');
      copiaTesto(t, function () { var c = sez.querySelector('[data-copiato]'); if (c) c.hidden = false; });
    });
  });

  /* ── Recesso (art. 54-bis del Codice del Consumo): il modulo prepara l'email, niente si salva ── */
  var apri = document.querySelector('[data-recesso-apri]'), rec = document.getElementById('recesso');
  var mr = document.getElementById('modulo-recesso');
  if (apri && rec && mr && document.getElementById('r-nome')) {
    var dopo = rec.querySelector('[data-recesso-dopo]'), testoRecesso = '';
    apri.addEventListener('click', function () {
      rec.hidden = false;
      apri.setAttribute('aria-expanded', 'true');
      rec.scrollIntoView({ block: 'start', behavior: calmo ? 'auto' : 'smooth' });
      document.getElementById('r-nome').focus({ preventScroll: true });
    });
    var regoleR = {
      nome: function (v) { return v.trim().length > 3 && /\s/.test(v.trim()); },
      email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); },
      ordine: function (v) { return v.trim().length > 1; },
      prodotti: function (v) { return v.trim().length > 2; }
    };
    function segnaR(n) {
      var el = document.getElementById('r-' + n), ok = regoleR[n](el.value);
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      var er = document.getElementById('errore-r-' + n); if (er) er.hidden = ok;
      return ok;
    }
    Object.keys(regoleR).forEach(function (n) {
      var el = document.getElementById('r-' + n);
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') segnaR(n); });
    });
    function vr(n) { return document.getElementById('r-' + n).value.trim(); }
    mr.addEventListener('submit', function (ev) {
      var veroR = !mr.getAttribute('data-email');   /* Shopify: la dichiarazione parte col modulo */
      if (!veroR) ev.preventDefault();
      var primo = null;
      Object.keys(regoleR).forEach(function (n) { if (!segnaR(n) && !primo) primo = document.getElementById('r-' + n); });
      if (primo) { ev.preventDefault(); primo.focus(); return; }
      if (veroR) {   /* se Shopify rifiuta l'invio, la pagina rimette ordine e prodotti (sections/maya-recesso.liquid) */
        try { sessionStorage.setItem('maya-recesso', JSON.stringify({ o: vr('ordine'), p: vr('prodotti') })); } catch (er) {}
        return;
      }
      var ora = new Date();
      var dati = {
        nome: vr('nome'), email: vr('email'), ordine: vr('ordine'), prodotti: vr('prodotti'),
        data: ora.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' }),
        ora: ora.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
      };
      testoRecesso = (mr.getAttribute('data-modello') || '').replace(/\{(\w+)\}/g, function (x, k) { return k in dati ? dati[k] : x; });
      testoRecesso = testoRecesso.replace(/\bil (8|11) /g, "l'$1 ");   /* «l'8 ottobre», non «il 8» */
      var oggetto = (mr.getAttribute('data-oggetto') || '') + ' – ' + dati.nome;
      window.location.href = 'mailto:' + mr.getAttribute('data-email') + '?subject=' + encodeURIComponent(oggetto) +
        '&body=' + encodeURIComponent(testoRecesso);
      var c = dopo.querySelector('[data-copiato]'); if (c) c.hidden = true;
      dopo.hidden = false;
      dopo.scrollIntoView({ block: 'center', behavior: calmo ? 'auto' : 'smooth' });
      dopo.focus({ preventScroll: true });
    });
    var cr = rec.querySelector('[data-recesso-copia]');
    if (cr) cr.addEventListener('click', function () {
      copiaTesto(testoRecesso, function () { var c = dopo.querySelector('[data-copiato]'); if (c) c.hidden = false; });
    });
  }

  /* ── versione chiara / scura: la scelta resta nel browser (data-tema lo mette già lo script nella testa) ── */
  var temaMeta = document.querySelector('meta[name="theme-color"]');
  document.querySelectorAll('[data-tema-btn]').forEach(function (b) {
    b.addEventListener('click', function () {
      var chiaro = doc.getAttribute('data-tema') !== 'chiaro';
      if (!calmo) {
        doc.classList.add('tema-cambia');
        window.setTimeout(function () { doc.classList.remove('tema-cambia'); }, 450);
      }
      if (chiaro) doc.setAttribute('data-tema', 'chiaro'); else doc.removeAttribute('data-tema');
      if (temaMeta) temaMeta.setAttribute('content', chiaro ? '#F0E8DA' : '#10120F');
      try { localStorage.setItem('maya-tema', chiaro ? 'chiaro' : 'scuro'); } catch (e) {}
    });
  });

  /* ── banner cookie di una riga ── */
  var barra = document.getElementById('cookie-bar');
  if (barra) {
    var chiuso = false;
    try { chiuso = localStorage.getItem('maya-cookie-ok') === '1'; } catch (e) {}
    if (!chiuso) { barra.hidden = false; doc.classList.add('cookie-aperto'); }
    barra.querySelector('.cookie-bar__x').addEventListener('click', function () {
      barra.hidden = true;
      doc.classList.remove('cookie-aperto');
      try { localStorage.setItem('maya-cookie-ok', '1'); } catch (e) {}
    });
  }
})();
